import policyApi from '@/services/apis/policy'
import { QueryAddressTypeEnum, WhiteListAuditStatusEnum } from '@/services/apis/policy/model'
import { useEffect, useState } from 'react'
import { AddressBookModel } from '@/services/apis/policy/model'
import logger from '@/services/logger'
import { DEFAULT_PAGE_SIZE } from '@/constants'

export const useGetWhiteListAddressBook = (blockchainTypeKey: string, searchVal?: string) => {
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [data, setData] = useState<AddressBookModel[]>([])
  useEffect(() => {
    if (!blockchainTypeKey) {
      logger.debug('blockchainTypeKey为空，不获取白名单')
      return
    }
    setLoading(true)
    policyApi
      .getAddressBookList({
        blockchainTypeKey,
        auditStatus: WhiteListAuditStatusEnum.passed,
        type: 2,
        queryStr: searchVal,
        page: currentPage,
        pageSize: DEFAULT_PAGE_SIZE,
      })
      .then(res => {
        if (res.success) {
          setData(res.data)
        }
      })
      .finally(() => setLoading(false))
  }, [searchVal, currentPage, blockchainTypeKey])
  useEffect(() => {
    setCurrentPage(1)
  }, [searchVal, blockchainTypeKey])
  return {
    data,
    loading,
    currentPage,
    setCurrentPage,
  }
}

export const useGetWhiteListAddressCount = (blockchainTypeKey: string) => {
  const [count, setCount] = useState(0)
  useEffect(() => {
    policyApi
      .getAddressBookCount({
        auditStatus: WhiteListAuditStatusEnum.passed,
        type: QueryAddressTypeEnum.whitelist,
        blockchainTypeKey,
      })
      .then(res => {
        if (res.success) {
          setCount(res.data)
        }
      })
  }, [blockchainTypeKey])
  return count
}
